import { graphql } from 'react-relay';

import useMutation from '@zego/mutations/useMutation';

const mutation = graphql`
  mutation usePrivateHireEstimateResultMutation(
    $input: PrivateHirePriceEstimate2Input!
  ) {
    result: getPrivateHirePriceEstimate2(input: $input) {
      estimateResult {
        state
        ...estimateLead @relay(mask: false)
        ...PrivateHireQuickEstimatesGbContainer_estimateResult
      }
    }
  }
`;

export default function usePrivateHireEstimateResult() {
  return useMutation(mutation);
}
